import styled from 'styled-components'

export const Container = styled.div`
  height: inherit;
  @media only percy {
    visibility: hidden;
  }
`
